import Vue from "vue";
import App from "./App.vue";
import api from "./api";
import VueI18n from "vue-i18n";
// 引入指令
import Directive from "@/directive";

Vue.config.productionTip = false;

// 挂载到 Vue 原型
Vue.prototype.$api = api;
Vue.use(Directive);

// 国际化插件引入
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "zh-CN", // 默认语言为英文
  messages: {
    "zh-CN": require("./locales/zh-CN.js").default,
    en: require("./locales/en.js").default,
  },
});
new Vue({
  i18n,
  render: (h) => h(App),
}).$mount("#app");
